/* block */
(function() {
  if (window.location.pathname.indexOf('/products/') !== -1) {
    var title = document.title.toLowerCase();
    var isBedroom = /bed|mattress|headboard|wardrobe|dresser|chest|drawer|tallboy|lowboy|bedside/.test(title);
    var isLiving = /sofa bed|coffee table|couch|recliner|lounge/.test(title);
    if (isBedroom && !isLiving) {
      var targetWord = 'bedroom';
      var els = document.querySelectorAll('h2, h3, p, li, span, div.pf-78_');
      els.forEach(function(el) {
        if (el.children.length === 0 && el.textContent.indexOf('living room') !== -1) {
          if (el.textContent.indexOf('Is the') !== -1 || el.textContent.indexOf('excellent choice') !== -1 || el.textContent.indexOf('ideal fit') !== -1) {
            el.innerHTML = el.innerHTML.replace(/living room/gi, targetWord).replace(/Living Room/gi, 'Bedroom');
          }
        }
      });
    }
  }
})();
